export interface PekerjaanUpah {
  wo_plan_d_id: number;
  wo_plan_id?: number;
  wo_order_id?: number;
  kode_wo: string;
  pic: string;
  proses: string;
  qty: number;
  harga: number;
  tgl_mulai?: string | null;
  tgl_selesai?: string | null;
  subtotal: number;
}

export interface PreviewPekerja {
  pic: string;
  jumlah_pekerjaan: number;
  total_qty: number;
  total_upah: number;
  pekerjaan: PekerjaanUpah[];
}

export interface PencairanUpah {
  id: number | string;
  nomor: string;
  site_id?: number;
  pic: string;
  awal?: string;
  akhir?: string;
  periode_awal?: string;
  periode_akhir?: string;
  tgl?: string;
  tanggal?: string;
  tgl_cair?: string;
  created_at?: string;
  created_by?: string;
  total_item: number;
  total_qty: number;
  total_upah: number;
  keterangan?: string;
  pdf_url?: string;
  details?: PekerjaanUpah[];
  detail?: PekerjaanUpah[];
}

export const rupiah = new Intl.NumberFormat('id-ID', {
  style: 'currency', currency: 'IDR', maximumFractionDigits: 0,
});

export const formatDate = (value?: string | null, withTime = false) => {
  if (!value) return '—';
  const normalized = value.includes('T') ? value : value.replace(' ', 'T');
  return new Intl.DateTimeFormat('id-ID', withTime
    ? { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
    : { day: '2-digit', month: 'short', year: 'numeric' }
  ).format(new Date(normalized));
};

export const getError = (error: any) =>
  error?.response?.data?.message || error?.message || 'Terjadi kesalahan. Silakan coba lagi.';
